import { Injector } from '@angular/core';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { getConditionalSettingsForm } from '../../conditional-settings-configurations';
import {
  getDefaultBaseSettingsConfigFormly,
  generateGenericLabelValueSettingsContentConfig,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  defaultRadioConfigFormModel,
  radioFieldParseIntoSettingsFormModel,
  radioFieldUpdateFromSettingsFormModel,
} from '../radio-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class RadioFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...defaultRadioConfigFormModel,
      defaultValue: null,
      conditionalSettings: { settings: [] },
    };
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      generateGenericLabelValueSettingsContentConfig('Radio Options'),
      {
        key: 'defaultValue',
        type: EIremboFormlyFieldTypes.customdropdown,
        className: 'mt-2 mb-5',
        props: {
          label: 'Default Value',
          disabled: false,
          required: false,
          placeholder: 'Enter default Value',
          bindLabel: 'label',
          bindValue: 'value',
          multiple: false,
          options: [],
        },
        id: 'defaultValue',
        expressions: {
          'props.options':
            'model?.contentSection?.optionLabelValuePairs ? model?.contentSection?.optionLabelValuePairs: []',
        },
      },
      getConditionalSettingsForm(this.formBuilderService),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel() {
    return radioFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return radioFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
